export const EXEMPT_REASONS = {
    NEW_ENTRY: "New Entry",
    LEAVE: "Leave",
    WEEK_OFF: "Weekend",
    REMOVED: "Removed"
}

export const LOGOUT_DAY = {
    SAME_DAY: "Same Day",
    NEXT_DAY: "Next Day"
}


export const MESSAGES = {
    CHANGES_SAVE_SUCCESS: 'Changes Saved Successfully.',
    CHANGES_SAVE_ERROR: 'Error Saving Changes',
    ROUTE_GENERATION_SUCCESS: "Routes Generated Successfully.",
    TRIP_GENERATION_SUCCESS: "Trips Generated Successfully.",
    FILL_REQUIRED_FIELDS: "Please fill in required fields.",
    TEMPLATE_UPLOAD_SUCCESS: "Template uploaded successfully.",
    VEHICLE_ASSIGNED: "Vehicle assigned successfully",
    ENTER_RANGE_VALUES: "Please enter range values.",
    INVALID_RANGE: "The range you have entered is invalid.",
    OVERLAPPING_RANGE: "There is range overlapping the current range.",
    ADD_RANGE: "Please add atleast one range",
    COST_COMPONENT_ADD_SUCCESS: "Cost component added succesfully.",
    COST_COMPONENT_REMOVE_SUCCESS: "Cost component removed succesfully.",
    RESOLVE_ERRORS: "Please resolve errors",
    NO_RESULT_FOUND: "No result found",
    INVALID_RESPONSE: "Invalid response form the server",
    SOMETHING_WENT_WRONG: 'Something went wrong',
    DELETE_SUCCESS: "Deleted Successfully",
    RECORD_CREATE_SUCCESS: "Record created successfully",
    INVALID_DATE: "Invalid Date Specified",
    TILL_DATE_SHOULD_NOT_BE_GREATER: "Till Date should not be grater than Today",
    INVALID_VEHICLE_NUMBER: 'Vehicle number is not valid',
    FROM_DATE_TO_DATE_SHOULD_NOT_EQUAL: 'From date and To date should not be equal',
    TO_DATE_SHOULD_NOT_BE_LESSER_THAN_TODAY: 'To Date should not be equal to Current date',
    VEHICLE_RTO_NUMBER_BLANK_ERROR: 'Please select vehicle RTO Number',
}

export const ROSTER_TYPE = {
    GENERAL: 'General',
    ADHOC: 'Adhoc',
    EMERGENCY_ADHOC: 'EmergencyAdhoc',
    PLANNED_MEDICAL_ADHOC: 'PlannedMedicalAdhoc'
}
export const GOOGLE_MAPS_API_KEY = null;//"AIzaSyBlYXWB8YJ8D6CG7CpMA5yu9n813oIcQRg";//TODO Provide api key for production.

export const COST_TYPE = {
    SLAB: 2,
    FIXED: 1
}

export const VEHICLE_SELECTION_DIFF_MINUTES = 180;

export const LOCAL_STORAGE_KEYS = {
    DRIVER_MANAGEMENT: 'driverManangementColumns',
    ACTOR_MANAGEMENT: 'actorManagementColumns',
    CONFIGURATION_MANAGEMENT: 'configurationManagementColumns',
    REPORT_MANAGEMENT: 'reportManagementColumns',
    EMPLOYEE_MANAGEMENT: 'employeeDetailsColumns',
    SCHEDULED_VS_ACTUAL: 'sceduledVsActualColumns',
    APPROVE_MANUAL_TRIP_CLOSE: 'approveManualTripClose',
    VEHICLE_MANAGEMENT: 'vehicleManagementColumns',

    IGNITION_ONOFF_REPORT: 'ignitionOnOffReport',
    DASHBOARD_LAYOUT: 'DashbaordLayout',
}

export const MAP_MARKER_MOVE_INTERVAL = 5000;// in milli second., at what interval the data refreshes.

export const TRACKING_TYPE = {
    LIVE: 'Live',
    HISTORY: 'History',
    HISTORY_PLAYING: 'History Playing',
    HISTORY_PAUSED: 'History Paused',
    HISTORY_STOPPED: 'History Stopped',
}

export const TAB_TYPES = {
    VEHICLES: "vehicles",
    GEOFENCE: "geofence",
}

export const TAB_VIEW = {
    EXPAND_GEOFENCE: 'expandgeofence',
}

export const RTO_REGEX = [
    // format: Indian
    /[A-Z]{2} [0-9]{2} [A-Z]{2} \d{4}$/i,
]

export const CONTACT_NUMBER_LENGTH = 16;

export const SIGNALR_PROPS = {
    GSM_SIGNAL: "gsmSignal",
    DOOR: "door",
    AC: "ac",
    SOS_PANIC: "sosPanic",
    IGNITION: "ignition",
    POWER: "power",
    TEMPERATURE: "temperature",
    FUEL: "fuel",
}
export const SIGNALR_STATUS = {
    IGNITION_ON: "ignitionOn",
    IGNITION_OFF: "ignitionOff",
}

export const USER_ROLES = {
    SUPER_ADMIN: "VTS-SuperAdmin",
    TENANT_ADMIN: "VTS-TenantAdmin",
    SUPERVISOR: "VTS-Supervisor",
}

export const VEHICLE_DETAILS_CALLED_FROM = {
    POPUP: 'POPUP',
    VEHICLE_LIST: 'VEHICLE_LIST',
}

export const VEHICLE_SPEED_LIMIT = {
    SAFE_SPEED: 'safe',
    HIGH_SPEED: 'high',
    MODERATE_SPEED: 'moderate',
}

export const DEFAULT_SPEED_LIMIT_COLORS = {
    SAFE_SPEED: '#00ff00',
    HIGH_SPEED: '#ff0000',
    MODERATE_SPEED: '#ffff00',
}

export const MAP_CONNECTION_STATUS = {
    CONNECTING : 'CONNECTING',
    CONNECTED: 'CONNECTED'

}
export const IMMOBILIZE_STATUS = {
    RESUMING : 'RESUMING',
    STOPPED: 'STOPPED'

}
